module.exports = __webpack_public_path__ + "static/media/throphy3.6cb8cba3.png";